import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeopleIdCard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people-id-card, profile, user-account, badge, person"><path d="M19.75 2.75H4.25V21.25H19.75V2.75Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12.25" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M16 21C16 18.7909 14.2091 17 12 17C9.79086 17 8 18.7909 8 21" stroke="currentColor" strokeWidth="1.5"/><path d="M9 6.25H15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPeopleIdCard;
